import React, { useRef, useState } from "react";
import { Icon } from "components";
import { Tooltip } from "reactstrap";
import * as Scrivito from "scrivito";

export const TooltipIcon = Scrivito.connect(({ description }) => {
  const [open, setOpen] = useState(false);
  const inputRef = useRef(null);
  const toggle = () => setOpen(!open);

  if (!description) {
    return null;
  }

  return (
    <div
      className="position-absolute top-0 end-0 p-1 cursor-pointer"
      onClick={toggle}
      ref={inputRef}
      onMouseLeave={() => open && toggle()}
    >
      <Icon
        iconName="fa-regular fa-circle-exclamation"
        className="text-gray-400"
        size="lg"
        data-testid="tooltip-icon"
      />
      <Tooltip
        isOpen={open}
        target={() => inputRef.current}
        placement="top"
        className="text-gray-400"
      >
        {description}
      </Tooltip>
    </div>
  );
});
